'use es6';

import { Record } from 'immutable';
import I18n from 'I18n';
export const ENTITY_FINDERS = {
  AD_TARGETING_FACET: 'AD_TARGETING_FACET',
  TYPEAHEAD: 'TYPEAHEAD'
};
export const LinkedInTargetingFacets = {
  GENDERS: 'genders',
  INDUSTRIES: 'industries',
  JOB_FUNCTIONS: 'jobFunctions',
  SENIORITIES: 'seniorities',
  AGE_RANGES: 'ageRanges',
  STAFF_COUNT_RANGES: 'staffCountRanges',
  EMPLOYERS: 'employers',
  EMPLOYERS_PAST: 'employersPast',
  EMPLOYERS_ALL: 'employersAll',
  GROUPS: 'groups',
  TITLES: 'titles',
  TITLES_PAST: 'titlesPast',
  TITLES_ALL: 'titlesAll',
  SKILLS: 'skills',
  SCHOOLS: 'schools',
  FOLLOWED_COMPANIES: 'followedCompanies',
  DEGREES: 'degrees',
  FIELDS_OF_STUDY: 'fieldsOfStudy',
  YEARS_OF_EXPERIENCE_RANGES: 'yearsOfExperienceRanges',
  FIRST_DEGREE_CONNECTION_COMPANIES: 'firstDegreeConnectionCompanies',
  INTERESTS: 'interests',
  BEHAVIORS: 'memberBehaviors',
  COMPANY_CATEGORY: 'companyCategory',
  GROWTH_RATE: 'growthRate'
};
export const YEARS_OF_EXPERIENCE_URNS = {
  ONE_YEAR: 'urn:li:yearsOfExperience:1',
  TWO_YEARS: 'urn:li:yearsOfExperience:2',
  THREE_YEARS: 'urn:li:yearsOfExperience:3',
  FOUR_YEARS: 'urn:li:yearsOfExperience:4',
  FIVE_YEARS: 'urn:li:yearsOfExperience:5',
  SIX_YEARS: 'urn:li:yearsOfExperience:6',
  SEVEN_YEARS: 'urn:li:yearsOfExperience:7',
  EIGHT_YEARS: 'urn:li:yearsOfExperience:8',
  NINE_YEARS: 'urn:li:yearsOfExperience:9',
  TEN_YEARS: 'urn:li:yearsOfExperience:10',
  ELEVEN_YEARS: 'urn:li:yearsOfExperience:11',
  TWELVE_PLUS: 'urn:li:yearsOfExperience:12'
};
export const YEARS_OF_EXPERIENCE_ORDER = [YEARS_OF_EXPERIENCE_URNS.ONE_YEAR, YEARS_OF_EXPERIENCE_URNS.TWO_YEARS, YEARS_OF_EXPERIENCE_URNS.THREE_YEARS, YEARS_OF_EXPERIENCE_URNS.FOUR_YEARS, YEARS_OF_EXPERIENCE_URNS.FIVE_YEARS, YEARS_OF_EXPERIENCE_URNS.SIX_YEARS, YEARS_OF_EXPERIENCE_URNS.SEVEN_YEARS, YEARS_OF_EXPERIENCE_URNS.EIGHT_YEARS, YEARS_OF_EXPERIENCE_URNS.NINE_YEARS, YEARS_OF_EXPERIENCE_URNS.TEN_YEARS, YEARS_OF_EXPERIENCE_URNS.ELEVEN_YEARS, YEARS_OF_EXPERIENCE_URNS.TWELVE_PLUS];
const EMPLOYER_FACETS = [LinkedInTargetingFacets.EMPLOYERS, LinkedInTargetingFacets.EMPLOYERS_PAST, LinkedInTargetingFacets.EMPLOYERS_ALL];
const JOB_FUNCTION_FACETS = [LinkedInTargetingFacets.JOB_FUNCTIONS];
const TITLE_FACETS = [LinkedInTargetingFacets.TITLES, LinkedInTargetingFacets.TITLES_PAST, LinkedInTargetingFacets.TITLES_ALL];
const SENIORITY_FACETS = [LinkedInTargetingFacets.SENIORITIES];
const INDUSTRY_FACETS = [LinkedInTargetingFacets.INDUSTRIES];
const SIZE_FACETS = [LinkedInTargetingFacets.STAFF_COUNT_RANGES];
const COMPANY_NAME_FACETS = [LinkedInTargetingFacets.FOLLOWED_COMPANIES, LinkedInTargetingFacets.FIRST_DEGREE_CONNECTION_COMPANIES, LinkedInTargetingFacets.EMPLOYERS, LinkedInTargetingFacets.EMPLOYERS_PAST, LinkedInTargetingFacets.EMPLOYERS_ALL];
const DEFAULT_ENTITY_LIMIT = 100;
const EMPLOYER_ENTITY_LIMIT = 200;

const getDetailedTargetingFacetEntityLimit = facetName => {
  if (EMPLOYER_FACETS.includes(facetName)) {
    return EMPLOYER_ENTITY_LIMIT;
  }

  return DEFAULT_ENTITY_LIMIT;
};

export const getEntityLimitMet = (currentFacet, detailedTargeting) => {
  const facetEntityLimit = getDetailedTargetingFacetEntityLimit(currentFacet.facetName);
  const optionCount = detailedTargeting.filter(targeting => targeting.facet === currentFacet.facetName).size;
  return [facetEntityLimit, facetEntityLimit <= optionCount];
};
export const LinkedInTargetingFacetRecord = Record({
  facetName: '',
  availableEntityFinders: [],
  entityTypes: [],
  $URN: ''
});
export const IncompatibleFacetErrorTypes = {
  JOB_FUNCTIONS: 'jobFunctions',
  TITLES: 'titles',
  SENIORITIES: 'seniorities',
  INDUSTRIES: 'industries',
  SIZE: 'staffCountRanges',
  COMPANIES: 'companies'
};
export const LinkedInErrorTypes = Object.assign({}, Object.keys(IncompatibleFacetErrorTypes), {
  ENTITY_LIMIT_MET: 'ENTITY_LIMIT_MET'
});
export const getIncompatibleFacetErrorType = (currentFacet, selectedFacets) => {
  const isJobFunction = JOB_FUNCTION_FACETS.includes(currentFacet.facetName);
  const isSeniority = SENIORITY_FACETS.includes(currentFacet.facetName);
  const isIndustry = INDUSTRY_FACETS.includes(currentFacet.facetName);
  const isSize = SIZE_FACETS.includes(currentFacet.facetName);
  const isTitle = TITLE_FACETS.includes(currentFacet.facetName);
  const isCompanyName = COMPANY_NAME_FACETS.includes(currentFacet.facetName);
  const hasJobFunction = selectedFacets.find(facet => JOB_FUNCTION_FACETS.includes(facet));
  const hasSeniority = selectedFacets.find(facet => SENIORITY_FACETS.includes(facet));
  const hasIndustry = selectedFacets.find(facet => INDUSTRY_FACETS.includes(facet));
  const hasSize = selectedFacets.find(facet => SIZE_FACETS.includes(facet));
  const hasTitle = selectedFacets.find(facet => TITLE_FACETS.includes(facet));
  const hasCompanyName = selectedFacets.find(facet => COMPANY_NAME_FACETS.includes(facet));

  if (isTitle && hasJobFunction) {
    return IncompatibleFacetErrorTypes.JOB_FUNCTIONS;
  }

  if (isJobFunction && hasTitle || isSeniority && hasTitle) {
    return IncompatibleFacetErrorTypes.TITLES;
  }

  if (isTitle && hasSeniority) {
    return IncompatibleFacetErrorTypes.SENIORITIES;
  }

  if (isIndustry && hasCompanyName || isSize && hasCompanyName) {
    return IncompatibleFacetErrorTypes.COMPANIES;
  }

  if (isCompanyName && hasIndustry) {
    return IncompatibleFacetErrorTypes.INDUSTRIES;
  }

  if (isCompanyName && hasSize) {
    return IncompatibleFacetErrorTypes.SIZE;
  }

  return null;
};
export const getLinkedInFacetError = (currentFacet, detailedTargeting, allSelectedFacets) => {
  const [limit, entityLimitMet] = getEntityLimitMet(currentFacet, detailedTargeting);

  if (entityLimitMet) {
    return {
      type: LinkedInErrorTypes.ENTITY_LIMIT_MET,
      message: I18n.text(`creation.targeting.detailedTargetingFacetLimitMet.${currentFacet.facetName}`, {
        limit
      })
    };
  }

  const incompatibleFacetType = getIncompatibleFacetErrorType(currentFacet, allSelectedFacets);

  if (incompatibleFacetType) {
    return {
      type: incompatibleFacetType,
      message: I18n.text(`creation.targeting.detailedTargetingModal.facetIncompatibilityErrors`, {
        facetName: I18n.text(`creation.targeting.detailedTargetingTypes.${currentFacet.facetName}`),
        incompatibleFacetType: I18n.text(`creation.targeting.detailedTargetingModal.incompatibleFacetTypes.${incompatibleFacetType}`)
      })
    };
  }

  return null;
};